@import '~less/global-variables';

/**
 * TrustRoots core layout styles
 */

/* 300ms delay to 0ms
 * Modern IEs need this CSS to stop adding 300ms delay to touch click events
 * @link http://developer.telerik.com/featured/300-ms-click-delay-ios-8/
 */
a[href],
button {
  touch-action: manipulation;
  cursor: pointer;
}

html,
body {
  height: 100%;
  background-color: @body-bg;
}

.container-spacer {
  margin-top: (@navbar-height + 30px);
}

.container-fullscreen {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding-bottom: 130px;
  &.container-spacer {
    top: var(--tr-header-height, @navbar-height);
    margin-top: 0;
  }
}
.container-error {
  @media (min-width: @screen-sm-min) {
    padding-top: 200px;
  }
  @media (min-width: @screen-md-min) {
    padding-top: 300px;
  }
}

// Horizontal divider with "rainbow" color reel
hr {
  position: relative;
  height: 0.15em;
  margin: 40px auto;
  padding: 0;
  border: 0;
  overflow: hidden;
  background: @color-reel-3;
  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    height: 0.15em;
    width: 10em;
    background: @brand-primary;

    // Rainbow style hr
    box-shadow:
      10em 0 0 0 @color-reel-0,
      20em 0 0 0 @color-reel-1,
      30em 0 0 0 @color-reel-2,
      40em 0 0 0 @color-reel-3,
      50em 0 0 0 @color-reel-4,
      60em 0 0 0 @color-reel-3,
      70em 0 0 0 @color-reel-2,
      80em 0 0 0 @color-reel-1;
  }
  &.hr-white {
    background: #fff;
    &:before {
      background: #fff;
      box-shadow: none;
    }
  }
  &.hr-gray {
    background: @gray-lighter;
    &:before {
      background: @gray-lighter;
      box-shadow: none;
    }
  }
  &.hr-xs {
    width: 10%;
  }
  &.hr-tight {
    margin: 20px auto;
  }
}

/**
 * Main content area. Everything else except header and footer.
 */
#tr-main {
  clear: both;
  overflow: auto;
  outline: none;
  padding-bottom: @article-padding-bottom;
  // Photo boards sit directly below the fixed header, whose height varies
  // between the signed-in and guest navigation and across viewport widths.
  > .board:not(.container-fullscreen):first-child {
    margin-top: var(--tr-header-height, 0px);
  }
  @media (max-width: @screen-xs-max) {
    padding-bottom: @article-padding-bottom-xs;
  }
}
